module.exports = __webpack_public_path__ + "media/metronic/_theme/media/files/doc-3b155c14b462a54b8e1372c4ec4a810a.svg";